module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offstage-wrapper"
  }, [_c('h1', {
    staticClass: "main-title individual grid-container"
  }, [_vm._v("Off Stage")]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation off-stage layer3"
  }), _vm._v(" "), _c('div', {
    staticClass: "offstage-list layer2"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "grid-container grid-100"
    }, [_c('div', {
      staticClass: "grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-item grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video-header grid-100 grid-parent"
    }, [_c('div', {
      staticClass: "video"
    }, [_c('iframe', {
      attrs: {
        "id": "main-video",
        "src": item.video_id_url,
        "width": "640",
        "height": "352",
        "frameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6665fba6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OffStage.vue
// module id = 286
// module chunks = 0